/**
 * @generated SignedSource<<6ba93f5c5332046ac7648f3d1b6b6e92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfoAndContactLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSidebarSellerInfoAndContact_user">;
  readonly " $fragmentType": "PdpRespSidebarSellerInfoAndContactLazy_user";
};
export type PdpRespSidebarSellerInfoAndContactLazy_user$key = {
  readonly " $data"?: PdpRespSidebarSellerInfoAndContactLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoAndContactLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSidebarSellerInfoAndContact_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9be13d3f33af8a6a00447a94bff4a123";

export default node;
